import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  putApiIntegrationsProductItemsUnlock,
  type IntegrationProvider,
  type UnlockProductItemIntegrationSyncRequest,
} from "apiClients/base-generated";
import { getHeyApiRequestOptions, normalizeHeyApiLang } from "apiClients/base/heyApiRequestOptions";

function heyApiResultToError(err: unknown): Error {
  const message = typeof err === "string" ? err : JSON.stringify(err);
  return new Error(message);
}

export type IntegrationProductsUnlockMutationVariables = {
  integrationProvider: IntegrationProvider;
  integrationSyncIds: number[];
};

function buildUnlockBody(vars: IntegrationProductsUnlockMutationVariables): UnlockProductItemIntegrationSyncRequest {
  return {
    integrationProvider: vars.integrationProvider,
    integrationSyncIds: vars.integrationSyncIds,
  };
}

export function useIntegrationProductsUnlockMutation(locale: string | null | undefined) {
  const queryClient = useQueryClient();
  const lang = normalizeHeyApiLang(locale);

  return useMutation({
    mutationFn: async (vars: IntegrationProductsUnlockMutationVariables) => {
      if (!vars.integrationSyncIds.length) {
        throw new Error("Inga integrationssynk-ID:n att låsa upp.");
      }
      const result = await putApiIntegrationsProductItemsUnlock({
        ...getHeyApiRequestOptions(lang),
        body: buildUnlockBody(vars),
      });
      if (result.error) {
        throw heyApiResultToError(result.error);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["integration-products"] });
    },
  });
}
